import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM, ROUTE_ENUM } from 'enums';
import { queryClient } from 'App';
import { useNavigate } from "react-router";

interface UpdateFixedMeasurementDetailsType {
  uuid: string | null;
  date: string;
  start: string;
  end: string;
  comment: string;
  employeeUuid: string;
}

const useEditFixedMeasurementOrder = (
  options?: UseMutationOptions<any, Error, UpdateFixedMeasurementDetailsType>
) => {
  const navigate = useNavigate();
  return useMutation({
    ...options,
    mutationKey: ['editFixedMeasurementOrder'],
    mutationFn: async ({ uuid, date, start, end, comment, employeeUuid }) => {
      return axiosInstance.put(`/orders/determining-measurement/update/${uuid}`, {
        date,
        start,
        end,
        comment,
        employeeUuid,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie aktualizacji ustalonego pomiaru...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-fixed-measurement',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Ustalony pomiar został zaktualizowany pomyślnie',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-fixed-measurement',
      });
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      navigate(ROUTE_ENUM.ORDERS_LIST);
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji ustalonego pomiaru',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-fixed-measurement',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useEditFixedMeasurementOrder;
